import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import CustomDateInput from "../../../../../../../Components/CustomInputs/CustomDateInput";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { Box } from "@mui/material";
import { Paragraph } from "@nn-design-system/react-component-library";

const ChildcareDateOfClaimToField: React.FC = () => {
   const dispatch = useDispatch();

   const DateOfClaimToValueChildcare = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 3
         )?.dateOfClaimTo
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   return (
      <Box>
         <CustomDateInput
            labelText="Ukončení ošetřování"
            name="DateOfClaimTo"
            value={DateOfClaimToValueChildcare || undefined}
            onChange={(val: string | null) => {
               dispatch(
                  updateFirstStepDynamicFields({
                     value: val,
                     field: "dateOfClaimTo",
                     typeOfClaimEnum: 3,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               "childcare.DateOfClaimTo",
               claimFieldErrorsMessages
            )}
            dependencyValue={shouldRenderSpecField(
               "childcare",
               "DateOfClaimTo",
               visibilityMatrixes
            )}
         />
         <Paragraph variant="Small" mt=".75rem" hasMargin={false}>
            Pokud ještě nedošlo k ukončení ošetřování, vyplňte pouze její
            počátek.
         </Paragraph>
      </Box>
   );
};

export default ChildcareDateOfClaimToField;
